import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportInvoice = props => <ReportWorkspace type="invoice" {...props} />;

export default ReportInvoice;
